import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import BorderSides from "%/dynamic-component-editor/options/border-sides";

export default class BorderOptions extends BaseOptionsBundle {

  optionTitle = "Border";
  static optionClassName = "i-dynamic-border";

  constructor(values = {}) {
    super(values, [
      BorderSides,
    ]);
  }
}
